<div class="card custom-card my-1 border-0">
  <div class="card-body mb-1">
    <div class="row mb-3">
      <label class="col-form-label col-auto">
        <i class="bi bi-search me-2"></i>
        ค้นหาข้อมูล
      </label>
    </div>
    <hr>
    <div class="row mb-1 ps-4 pe-4">
      <div class="col-xl-4 col-sm-12 mt-3">
        <div>
          <label>
            ชื่อผู้ใช้งาน / Username
          </label>
        </div>
        <div>
          <input type="text" [(ngModel)]="searchParams().userName" class="form-control" name="userName" id="userName">
        </div>
      </div>
      <div class="col-xl-4 col-sm-12 mt-3">
        <div>
          <label>
            ชื่อ - นามสกุล / FullName
          </label>
        </div>
        <div>
          <input type="text" class="form-control" name="fullName" id="fullName" [(ngModel)]="searchParams().fullName">
        </div>
      </div>
      <div class="col-xl-4 col-sm-12 mt-3">
        <div>
          <label>
            สถานะ / Status
          </label>
        </div>
        <div>
          <select class="form-select" [(ngModel)]="searchParams().enable" id="enable" name="enable">
            <option [ngValue]="undefined">--- เลือกทั้งหมด ---</option>
            <option [ngValue]="true">ใช้งาน (Active)</option>
            <option [ngValue]="false">ไม่ใช้งาน (InActive)</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mb-3 mt-5">
      <div class="col-12 text-start">
        <div class="text-center">
          <button type="button"
                  class="btn btn-custom btn-custom-theme me-2"
                  (click)="search()">
            <i class="bi bi-search me-2"></i>
            ค้นหา
          </button>
          <button type="button"
                  class="btn btn-custom btn-light me-2"
                  (click)="clear()">
            <i class="bi bi-arrow-clockwise me-2"></i>
            ล้างข้อมูล
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card custom-card my-3 border-0">
  <div class="card-body mb-3">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <span>
          รายการทั้งหมด {{ pageData()?.totalElements | number }} รายการ
        </span>
      </div>
      <div>
        <button class="btn btn-custom btn-custom-theme" (click)="openModel('เพิ่ม')"
                *hasAnyRole="['user_admin']">
          <i class="bi bi-plus-lg me-1"></i>
          <span>เพิ่มผู้ใช้งาน (New)</span>
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <thead class="color-black font-weight-light">
        <tr class="table-light text-center" style="background-color: #eeeeee;">
          <th nowrap scope="col" class="">ลำดับ /<br> No.</th>
          <th nowrap scope="col" class=""></th>
          <th nowrap scope="col" class="">ชื่อผู้ใช้งาน /<br> Username</th>
          <th nowrap scope="col" class="">ชื่อ - นามสกุล /<br> FullName</th>
          <th nowrap scope="col" class="">เบอร์ติดต่อ /<br> Telephone</th>
          <th nowrap scope="col" class="">อีเมล /<br> Email</th>
          <th nowrap scope="col" class="">สถานะ /<br> Status</th>
          <th nowrap scope="col" class="">บทบาท /<br> Role</th>

        </tr>
        </thead>
        <tbody class="table-borderless">
        <tr *ngIf="!pageData()?.content?.length">
          <td class="text-muted text-center" colspan="7">
            <app-not-found></app-not-found>
          </td>
        </tr>
        <tr *ngFor="let item of pageData()?.content; let i= index">
          <td class="text-center">{{ i + 1 }}</td>
          <td class="text-center">
            @if (item.ssoUserId === userData().sub) {
              <button class="btn btn-default"
                      (click)="openModelEdit(item)">
                <i class="bi bi-pencil"></i>
              </button>
            }
          </td>
          <td class="text-center">{{ item.userName }}</td>
          <td class="text-center">{{ item?.fullName }}</td>
          <td class="text-center">{{ item?.telephoneNo }}</td>
          <td class="text-center">{{ item.email }}</td>
          @if (hasAdminRole && userData().sub !== item.ssoUserId) {
            <td class="text-center">
              <div class="form-check form-switch d-flex align-items-center justify-content-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked{{ i }}"
                  name="enable"
                  [checked]="item.enable"
                  [disabled]="!hasAdminRole"
                  (click)="$event.preventDefault(); onStatusChange(item)"
                />
                <label
                  class="form-check-label ms-2"
                  for="flexSwitchCheckChecked{{ i }}"
                  [class.text-success]="item.enable"
                  [class.text-danger]="!item.enable"
                >
                  {{ item.enable ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
                </label>
              </div>
            </td>
          } @else {
            <td class="text-center">
              @if (item.enable) {
                เปิดใช้งาน (Active)
              } @else {
                ปิดใช้งาน (InActive)
              }
            </td>
          }
          @if (hasAdminRole && userData().sub !== item.ssoUserId) {
            <td class="text-center">
              <div class="form-check form-switch d-flex align-items-center justify-content-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckRole{{ i }}"
                  name="enable"
                  [checked]="item.admin"
                  (click)="$event.preventDefault(); onRoleChange(item)"
                />
                <label
                  class="form-check-label ms-2"
                  for="flexSwitchCheckRole{{ i }}"
                  [class.text-primary]="item.admin"
                  [class.text-secondary]="!item.admin"
                >
                  {{ item.admin ? "ADMIN" : "USER" }}
                </label>
              </div>
            </td>
          } @else {
            <td class="text-center">
              @if (item.admin) {
                ADMIN
              } @else {
                USER
              }
            </td>
          }
        </tr>
        </tbody>
      </table>
    </div>
    <ngb-pagination class="d-flex justify-content-center"
                    [maxSize]="5"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    [page]="pageData()?.number + 1"
                    (pageChange)="search($event)"
                    [pageSize]="pageData()?.size"
                    [collectionSize]="pageData()?.totalElements"></ngb-pagination>
  </div>
</div>

